module.exports = __webpack_public_path__ + "static/media/kudu3.a36997b9.jpg";